import { Badge, Box, Card, HStack, Icon, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { FiFolder } from 'react-icons/fi';
import { FolderEntry } from '../types';

type FolderSectionProps = {
  folders: FolderEntry[];
  onOpenFolder: (path: string) => void;
  formatTimestamp: (value?: string | null) => string;
};

const FolderSection: FC<FolderSectionProps> = ({
  folders,
  onOpenFolder,
  formatTimestamp,
}) => {
  if (folders.length === 0) {
    return (
      <Stack gap="3">
        <HStack justify="space-between">
          <Text fontWeight="medium" textTransform="uppercase" fontSize="xs" color="fg.muted">
            Folders
          </Text>
          <Text fontSize="xs" color="fg.muted">
            0 total
          </Text>
        </HStack>
        <Text color="fg.muted" fontSize="sm">
          No folders in this directory.
        </Text>
      </Stack>
    );
  }

  return (
    <Stack gap="3">
      <HStack justify="space-between">
        <Text fontWeight="medium" textTransform="uppercase" fontSize="xs" color="fg.muted">
          Folders
        </Text>
        <Text fontSize="xs" color="fg.muted">
          {folders.length} total
        </Text>
      </HStack>
      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} gap="3">
        {folders.map((folder) => (
          <Card.Root
            key={folder.id}
            variant="outline"
            borderRadius="xl"
            transition="all 0.2s ease"
            _hover={{ shadow: 'md', transform: 'translateY(-2px)' }}
            cursor="pointer"
            onClick={() => onOpenFolder(folder.path)}
          >
            <Card.Body gap="3">
              <HStack gap="3" align="flex-start">
                <Box
                  bg="bg.subtle"
                  borderRadius="md"
                  boxSize="10"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Icon as={FiFolder} boxSize="5" color="accent.500" />
                </Box>
                <Stack gap="1" flex="1">
                  <Text fontWeight="semibold" truncate>
                    {folder.name}
                  </Text>
                  <Text fontSize="xs" color="fg.muted">
                    Updated {formatTimestamp(folder.updatedAt)}
                  </Text>
                </Stack>
                <Badge variant="subtle" colorPalette="gray">
                  Folder
                </Badge>
              </HStack>
            </Card.Body>
          </Card.Root>
        ))}
      </SimpleGrid>
    </Stack>
  );
};

export default FolderSection;
